import { getCsrfTokenFromCookie } from "helpers/csrfToken";

export const loginCodeIsValid = code => !!code.length && !(code.length > 6);

const REQUEST_LOGIN_CODE = "/_allauth/browser/v1/auth/code/request";
const CONFIRM_LOGIN_CODE = "/_allauth/browser/v1/auth/code/confirm";
const CLEAR_LOGIN_CODE = "/accounts/clear_login_code/";

export const requestLoginCode = async ({ emailAddress, onSuccess, onFail }) => {
    const res = await fetch(REQUEST_LOGIN_CODE, {
        method: "POST",
        headers: {
            "X-Requested-With": "XMLHttpRequest", // backend is filtering out packets without this header
            "X-CSRFToken": getCsrfTokenFromCookie()
        },
        body: JSON.stringify({
            email: emailAddress
        })
    });

    const {
        status,
        errors = [],
        data: { flows = [] }
    } = await res.json();

    const loginByCodeData = flows.find(f => f.id === "login_by_code");

    if (status === 401 && loginByCodeData?.is_pending) {
        return onSuccess();
    } else {
        const message =
            errors[0]?.message ||
            "Something went wrong, please try again in a little bit.";

        return onFail(message);
    }
};

export const confirmLoginCode = async ({ loginCode, onSuccess, onFail }) => {
    const res = await fetch(CONFIRM_LOGIN_CODE, {
        method: "POST",
        headers: {
            "X-Requested-With": "XMLHttpRequest", // backend is filtering out packets without this header
            "X-CSRFToken": getCsrfTokenFromCookie()
        },
        body: JSON.stringify({
            code: loginCode
        })
    });

    const { status, errors = [] } = await res.json();

    if (status === 200) {
        return onSuccess();
    } else {
        const message =
            errors[0]?.message ||
            "Something went wrong, please try again in a little bit.";

        return onFail(message);
    }
};

export const clearLoginCode = async () => {
    return await fetch(CLEAR_LOGIN_CODE, {
        method: "POST",
        headers: {
            "X-Requested-With": "XMLHttpRequest", // backend is filtering out packets without this header
            "X-CSRFToken": getCsrfTokenFromCookie()
        }
    });
};
